import { Helmet } from "react-helmet";

export default function BlogPostSEO({ title, description, slug }) {
  return (
    <Helmet>
      <title>{title} | PT Supersoft Sistemindo</title>

      <meta name="description" content={`${description} `} />

      <link rel="canonical" href={`https://ptsupersoft.com/blogs/${slug}`} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={`${description} `} />
      <meta
        property="og:url"
        content={`https://ptsupersoft.com/blogs/${slug}`}
      />

      <meta name="ai-search-summary" content={`${description} `} />
      <meta
        name="ai-search-tags"
        content="Infor SunSystems, Hexagon EAM, case study, digital transformation"
      />
    </Helmet>
  );
}
